import React from 'react';
import { Modal as RNModal, View } from 'react-native';


const Modal: React.FC<any> = (props) => {
  const { isVisible, children, style, onBackdropPress } = props;
  return (
      <RNModal
        visible={isVisible}
        transparent
        animationType="none"
        onRequestClose={onBackdropPress}
      >
        <View 
          style={{flex: 1, backgroundColor: 'rgba(0,0,0,0.3)', ...style}}
          onStartShouldSetResponder={() => true}
          onResponderGrant={(evt) => {
            // Check if the touch is on the backdrop (not on modal content)
            if (evt.target === evt.currentTarget) {
              onBackdropPress?.();
            }
          }}
        >
          {children}
        </View>
      </RNModal>
  );
};

export default Modal;